import React, { useEffect, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import { FieldHelpManager } from '@vanilla/ui/FieldHelpManager.js';
import LoginPage from './pages/LoginPage.jsx';
import { Toaster } from '@/components/ui/sonner';
import { FullPageLoader } from '@/components/ui/spinner';
import ConfirmAlertHost from './components/ConfirmAlertHost.jsx';
import { LoadingProvider } from './context/LoadingContext.jsx';
import { createAppRouter } from './app/router.jsx';
import { AppQueryProvider } from './app/queryClient.jsx';

function AppGate() {
    const { isAuthenticated, bootstrapping, ssoPending, permsReady } = useAuth();
    const router = useMemo(() => createAppRouter(), []);

    useEffect(() => {
        if (isAuthenticated) {
            document.body.classList.add('crm-logged-in');
        } else {
            document.body.classList.remove('crm-logged-in');
        }
    }, [isAuthenticated]);

    if (bootstrapping || (ssoPending && !isAuthenticated)) {
        return <FullPageLoader message={ssoPending ? 'Signing in…' : 'Loading…'} />;
    }

    if (!isAuthenticated) {
        return <LoginPage />;
    }

    if (!permsReady) {
        return <FullPageLoader message="Loading…" />;
    }

    return <RouterProvider router={router} />;
}

export default function App() {
    useEffect(() => {
        FieldHelpManager.init();
        FieldHelpManager.enhanceAllForms();
    }, []);
    return (
        <AuthProvider>
            <LoadingProvider>
                <AppQueryProvider>
                    <AppGate />
                    <Toaster />
                    <ConfirmAlertHost />
                </AppQueryProvider>
            </LoadingProvider>
        </AuthProvider>
    );
}
